module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "words-from-the-old-ones"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "section-head"
  }, [_c('img', {
    attrs: {
      "alt": "wftoo.eps",
      "src": "images/wftoo_fmt.jpeg"
    }
  }), _c('a', {
    attrs: {
      "id": "words-from-the-old-ones-anchor"
    }
  })]), _c('a', {
    attrs: {
      "id": "words-from-the-old-ones-anchor"
    }
  }, [_c('p', {
    staticClass: "dtxnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("The Book of Shadows is a Wiccan workbook containing invocations, ritual patterns, spells, runes, rules governing magic, and so on. Some Books of Shadows are passed from one Wiccan to another, usually upon initiation, but the vast majority of Books of Shadows today are composed by each individual Wiccan.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "normal"
  }, [_vm._v("Don’t believe the stories in most other Wiccan books that one single Book of Shadows has been handed down from antiquity, for each sect of Wicca seems to claim that their own is the original, and they’re all different.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "normal"
  }, [_vm._v("Although until recently a Book of Shadows was usually hand-written, today typed or even photocopied versions are quite common. Some Wiccans are even computerizing their books—to create, as friends of mine call it, the “Floppy Disc of Shadows.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "normal"
  }, [_vm._v("To make your own Book of Shadows, begin with any blank book—these are available in most art stores and bookshops. If you cannot find a bound blank book, any lined exercise book will do. Simply write in this book any rituals, spells, invocations, and magical information that you have either composed or found elsewhere and would like to preserve.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "normal"
  }, [_vm._v("Remember—all Books of Shadows are suggestions as to ritual, not holy writ. Never feel tied down to these words. In fact, many Witches use three-ring binders, shuffling around pages, adding or subtracting information from their Book of Shadows at will.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "normal"
  }, [_vm._v("It is a good idea to copy your spells and rites by hand. Not only does this ensure that you’ve read the work completely, it also allows easier reading by candlelight. Ideally, all rites are memorized (there’s nothing more distracting than having to read or glance at the book), or created spontaneously, but if you would read your rites, be sure your copies are legible by flickering firelight.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Excerpted from ")]), _c('span', {
    staticClass: "normal"
  }, [_vm._v("Wicca: A Guide for the Solitary Practitioner")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(" by Scott Cunningham.")])]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Words from the Elder")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("O ye Daughters and Sons of the Earth, adore the Gods, and be blessed by them with the fullness of life.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Know that they have brought you to these writings, for herein lie the secrets of the Craft of Wicca, to serve and fulfill the keepers of the Wisdom, the tenders of the Sacred Flame of knowledge. Run the ancient rites with love and joy, and the Gods will confound those who work against you; but for those who work harm needlessly, their curse shall be the only fruit.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Remember, keep close to your heart, that you are of the Wise. No longer do you trod the ways of humanity; you skip on the path of Light, ever climbing from shadow to shadow to the highest realm of existence. But though we are bearers of truth, man does not wish to share our knowledge, so we meet in the shadows and run our rites beneath moonfilled skies. But we are happy.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Live life fully, for that is why we are here; refrain not from earthly life, for from such we grow and learn and understand, until such time that we are reborn to learn more, and to repeat this cycle till we have spiraled up the path to perfection, and can finally call the gods our kindred.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Walk the fields and forests; be refreshed by the cool winds and the touch of a nodding flower. The Sun and Moon sing in the ancient and wild places: the deserted seashore, the hushed valley, the raging waterfall. We are of the earth and should revere her, so walk lightly upon the ground and honor her.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Celebrate the rites on the appropriate days and seasons, and call the gods when the time is meet, but use the power only when necessary; not for frivolous ends. And know that using the power for harm be a perversion in the sight of the gods.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("But for those who love and magnify love, as the dew-drop magnifies the sun, the richness of life shall be your reward, and all of nature will celebrate.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("So love the gods, and harm none!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Blessed Be!")])]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Before Time Was")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Before time was, there was Dryghtyn; Dryghtyn was all, and all was Dryghtyn.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("And the vast expanse known as the universe was Dryghtyn; all-knowing, all-pervading, all-powerful, changeless, eternal.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("And space moved; Dryghtyn molded energy into twin forms, and so the gods were fashioned from Dryghtyn.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("The God and Goddess stretched and gave thanks to Dryghtyn, but darkness surrounded them. They were alone, solitary, save for the Dryghtyn.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("So they formed energy into gasses and gasses into planets and suns and moons; they sprinkled the universe with whirling globes and so the universe was given shape, by the hands of the God and Goddess.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Light arose and the sky was illuminated by a billion Suns, and the God and Goddess, satisfied by their works, rejoiced, and loved, and were one.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("From their union there sprang the seeds of all life, and of the human race, so that we might achieve incarnation upon the Earth.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("The Goddess chose the Moon as her living symbol, and the God the Sun as his living symbol, to remind the inhabitants of Earth of their fashioners.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("All are born, live, and die beneath the Sun and Moon; and all things come to pass there under, as has been the way of existence before time was.")])]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("The Nature of Our Way")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("As often as possible, the rites should be held in forests, by the seashore, on deserted mountaintops or near quiet, tranquil lakes. If this is impossible, some chamber will suffice, if it is readied with fumes or flowers.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Seek out the wisdom in books, rare manuscripts, and cryptic poems, if you will, but seek it out also in simple stones and fragile herbs, and in the cry of the wild bird. Listen to the whisperings of the wind and the roar of the ocean if you would discover magic, for it is here that the old secrets are preserved.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Books contain words, trees energies, and wisdom books ne’er dreamed of.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Ever remember that the old ways are constantly revealing themselves; therefore be as the river willow, that bends and sways with the winds of time; that which remains changeless shall outlive its spirit; but that which evolves and grows will shine for centuries.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("There can be no monopoly on wisdom; therefore share what you will with whom you will; but hide mystic ways from the eyes of those who would destroy, for to do otherwise increases their destruction.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Mock not the ways or spells of another, for who can say yours are greater in power or wisdom?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Take not one among you who serves to dominate you; who controls and manipulates your workings and reverences. Only within ourselves can true reverence for the old ones occur; therefore look with suspicion on those who would twist worship from you for their own gain.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("All should share equally in the workings; thus none shall grow contemptuous of others in our way.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Honor all living things, for we are of the stag, and the salmon, and the bee; so destroy not life, save it be to preserve your own.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Blessings of the ancient ones on all.")])]), _vm._v(" "), _c('p', {
    staticClass: "ahead"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("The Law")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" 1. This be the true and great law of the Wicca, ordained and consecrated for our use.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" 2. And this be the only law that the Wicca shall observe in council in the Circle.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" 3. All must obey the law if they be of the Craft.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" 4. The High Priestess shall be your mother, sister, and friend, and all shall obey her commands within the Circle, for she is the Goddess incarnate, and is to be respected. Common consent shall determine her successor, should she not appoint such by her own words.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" 5. The High Priest shall be your father, brother, and friend; and likewise you shall obey his desires within the Circle. For he is the God incarnate, and is to be respected. Common consent shall determine his successor, should the High Priest not appoint such by his own words.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" 6. The High Priestess and the High Priest shall each appoint aides, the Maiden and the Page, and their duties shall be to learn the High Priesthood such that they may perform all necessary rites and, with time, form their own coven. For the Craft must not die.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" 7. All shall be purified ere they step within the sacred Circle, which is anciently the Circle of Stones. All shall bathe and be purified with salt and herbs.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" 8. All shall be naked or robed, according to desire.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" 9. Give due worship to the Old Ones, as we have been taught.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("10. All shall observe the Sabbats with due ceremony, and after the rites there shall be feasting and dancing, much merriment, to rejoice in the turning of the wheel of the year.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("11. Likewise, all of the Wicca, once a month, shall meet to celebrate the March of the Moon and make magic in the God’s names.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("12. As often as possible, the rites shall be held in forests, by the seashore, on deserted mountaintops, or near quiet, tranquil lakes. But if this be impossible, then some chamber with adequate safety against discovery shall suffice, if it be properly purified with rosemary or frankincense.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("13. As far as possible make all your actions honorable; for all that you do shall return to you three-fold: three times ill or three times good.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("14. Seek out wisdom in books, rare manuscripts, and cryptic poems, if you will; but seek it out also in simple stones and fragile herbs and in the cry of the wild bird; listen to the whisperings of the wind and the roar of the ocean if you would master Wicca, for it be here that our secrets are preserved.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("15. Books contain words; trees energies and wisdom that words ne’er dreamed of.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("16. Make love with those who you will, but first be clean and free of bonds. And such shall not occur within the Circle, save it be for private rituals before the gods.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("17. All shall be properly admitted before attending our Circles, or learning our secrets; thus shall our clan be kept from our oppressors who yet wrong us.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("18. And because of such persecution, tell none who be not of the Wicca who your bond-sisters and bond-brothers be; nor tell them of the covenstead; nor the High Priestess; nor the High Priest. And speak not of your own membership: thus shall our persecutors be foiled.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("19. Let each write and cherish his own book; and memorize what you can. When danger trembles on the horizon, destroy the book, or have a sister or brother secret it elsewhere, to save it from discovery. Rewrite the book as soon as danger is passed.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("20. Let the tools be duly consecrated to our use, and put to no other.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("21. None but the Wicca shall see our tools and rites, nor hear of them.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("22. For even in these enlightened times, mankind eternally blames his own misery on the Wicca; he knows not that he brings it upon himself. Therefore we meet in the shadows, to preserve our love.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("23. Teach those who come to you, if they be worthy. For to keep the Wicca alive it must spread, and to keep it from a worthy person be bane.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("24. Those of the Wicca who break the law shall be given fair consideration in full coven.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("25. By common consent, the punishment shall be agreed upon, which shall be light. For the second offense, too, a light punishment shall be agreed upon. But for the third offense of the same law, then banishment shall be handed down to the sister or brother, and she or he shall be utterly avoided.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("26. But the punishment shall be light, save in case of grave danger or oath-breaking, for we be not as the new religion, with hellfire and angry jaws of death. We be of the old religion of wisdom and love, and communion with nature.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("27. Any of the Wicca who knowingly brings enemies into our midst shall be banished and utterly avoided.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("28. Honor all living things, for we are of the stag, and the salmon, and the bee; so destroy not life, save it be to preserve your own.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("29. A law may be changed, by common consent, if it be out of sense for the day; but this is not to be done lightly, nor for convenience, but with love and wisdom and the good of the Craft in mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("30. Blessings of the God and Goddess on all.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("HERE ENDS THE LAW")])])]), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "id": "words-from-the-old-ones-anchor"
    }
  }, [_c('span', {
    staticClass: "generated-style"
  })]), _c('a', {
    attrs: {
      "href": "#/Contents#x-contents-anchor"
    }
  }, [_vm._v("[contents]")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57a81760","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Words_From_the_Old_Ones.vue
// module id = 78
// module chunks = 0